export default {
	section_banner: {
		title: {
			one: 'One Tether',
		},
		main_title: {
			one: 'Credit card',
		},
		paragraph: {
			one: 'You can easily access your JPWorldPay balance with debit and prepaid cards or fund your daily purchases with one of your credit offerings.',
		},
		cta_buttons: {
			one: 'Get Started',
			two: 'Download App',
		},
	},
	creditcard_mid: {
		creditcard_lft_text: {
			heading: 'about Company',
			title: {
				one: 'JPWorldPay',
				two: 'Credit',
			},
			paragraph:
				'Buy now and pay later with ease using JPWorldPay. Take advantage of special financing options available for purchases over 10,000 yen at any location where JPWorldPay is accepted. Whether you are making everyday purchases or investing in something bigger, our flexible payment plans help you manage your budget without stress.',
			cta_buttons: 'About One Tether Credits',
		},
		creditcard_right_text: {
			heading: 'Terms & Conditions',
			title: {
				one: 'User',
				two: 'Agreement',
			},
			paragraph: {
				one: 'There is no interest if you pay the full amount within 6 months for every 10,000 yen purchase. If you do not pay your balance in full within six months, interest will be charged to your account from the date of purchase.',
				two: 'A minimum monthly payment is required. Subject to credit approval',
			},
			cta_buttons: 'View Terms & Conditions',
		},
	},
	credit_system_sec: {
		label: 'Fastest Payment System',
		title: {
			one: 'NEW JPWorldPay',
			two: 'Cashback',
		},
		paragraph: {
			one: 'Unlimited 3% cashback when purchasing One Get unlimited 2% for all other purchases. Be the first to find out when you can use it. Previous 2% cashback holders do not need to join the list. You will receive an automatic upgrade.',
		},
		cta_buttons: 'Cashback Details',
	},
	credit_system_right_sec: {
		label: 'Fastest Payment System',
		title: {
			one: 'NEW JPWorldPay',
			two: 'Cashback',
		},
		paragraph: {
			one: 'Unlimited 3% cashback when purchasing One Get unlimited 2% for all other purchases. Be the first to find out when you can use it. Previous 2% cashback holders do not need to join the list. You will receive an automatic upgrade.',
		},
		cta_buttons: 'Cashback Details',
	},
	section_newsletter: {
		label: 'SUBSCRIBE NEWSLETTER',
		title: {
			one: 'Subscribe',
			two: '& Get A Latest Update',
		},
		description: {
			one: 'Subscribe us & recieve our offers and updates in your inbox directly.',
			two: 'Get in touch to learn how our JPWorldPay solution can increase your business.',
		},
		form: {
			placeholder: 'Email ID',
			button: 'SUBSCRIBE NOW',
		},
	},
};
